import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function DonateScreen() {
  const [amount, setAmount] = useState('');
  const [customAmount, setCustomAmount] = useState('');
  const [donorName, setDonorName] = useState('');
  const [donorEmail, setDonorEmail] = useState('');
  const [message, setMessage] = useState('');

  const presetAmounts = [25, 50, 100, 250, 500];

  const handleAmountClick = (value: number) => {
    setAmount(value.toString());
    setCustomAmount('');
  };

  const handleDonate = () => {
    const finalAmount = parseFloat(customAmount || amount);
    if (!finalAmount || finalAmount <= 0) {
      alert('Please select or enter a valid donation amount');
      return;
    }

    alert('Mobile donation processing will be available soon. Please visit our website or contact us directly to make a donation.');
  };

  const handleEmailContact = () => {
    window.location.href = 'mailto:harvesthousetobique@gmail.com?subject=Donation Inquiry';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-[#B85C38] py-12 px-6 text-center">
        <h1 className="text-4xl font-bold text-white mb-3">Make a Donation</h1>
        <p className="text-lg text-white">Your generosity makes a real difference</p>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/" className="inline-block text-gray-600 hover:text-gray-900 mb-6">
          ← Back to Home
        </Link>

        <div className="bg-white rounded-xl p-8 shadow-md mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Your donation helps us:</h2>
          <div className="space-y-3 text-gray-700 text-lg">
            <p>• Provide free community meals</p>
            <p>• Support daily 12-Step recovery meetings</p>
            <p>• Fund Step Up housing for men in recovery</p>
            <p>• Keep our community center open</p>
            <p>• Provide case management and support</p>
          </div>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-md mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Select Amount</h2>

          <div className="grid grid-cols-3 md:grid-cols-5 gap-4 mb-6">
            {presetAmounts.map((value) => (
              <button
                key={value}
                onClick={() => handleAmountClick(value)}
                className={`py-4 rounded-lg font-bold text-lg transition-colors ${
                  amount === value.toString()
                    ? 'bg-[#B85C38] text-white'
                    : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                }`}
              >
                ${value}
              </button>
            ))}
          </div>

          <label className="block text-sm font-semibold text-gray-700 mb-2 mt-6">
            Or enter a custom amount
          </label>
          <input
            type="number"
            className="w-full border border-gray-300 rounded-lg p-3 text-lg mb-4"
            placeholder="Enter custom amount"
            value={customAmount}
            onChange={(e) => {
              setCustomAmount(e.target.value);
              setAmount('');
            }}
          />

          {(amount || customAmount) && (
            <div className="bg-[#E8DDD0] border border-[#B85C38] rounded-lg p-4 mb-6">
              <p className="text-lg font-bold text-gray-900">
                Donation Amount: ${parseFloat(customAmount || amount).toFixed(2)}
              </p>
            </div>
          )}

          <label className="block text-sm font-semibold text-gray-700 mb-2 mt-6">
            Full Name (Optional)
          </label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded-lg p-3 mb-4"
            placeholder="Your name"
            value={donorName}
            onChange={(e) => setDonorName(e.target.value)}
          />

          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Email (Optional)
          </label>
          <input
            type="email"
            className="w-full border border-gray-300 rounded-lg p-3 mb-4"
            placeholder="your@email.com"
            value={donorEmail}
            onChange={(e) => setDonorEmail(e.target.value)}
          />

          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Message (Optional)
          </label>
          <textarea
            className="w-full border border-gray-300 rounded-lg p-3 mb-4 h-32"
            placeholder="Share why this cause is important to you..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          <button
            onClick={handleDonate}
            className="w-full bg-[#B85C38] text-white py-4 rounded-lg font-bold text-lg hover:bg-[#A34C28] transition-colors mb-4"
          >
            Donate {amount || customAmount ? `$${parseFloat(customAmount || amount).toFixed(2)}` : ''}
          </button>

          <button
            onClick={handleEmailContact}
            className="w-full bg-gray-700 text-white py-4 rounded-lg font-bold hover:bg-gray-800 transition-colors"
          >
            Contact Us About Donating
          </button>
        </div>

        <div className="bg-[#E8DDD0] rounded-xl p-8 border-l-4 border-[#B85C38] mb-6">
          <h3 className="text-xl font-bold text-gray-900 mb-3">100% Goes to Impact</h3>
          <p className="text-gray-700 leading-relaxed">
            Every dollar you donate directly supports our programs and services.
          </p>
        </div>

        <div className="bg-[#E8DDD0] rounded-xl p-8 border-l-4 border-[#B85C38]">
          <h3 className="text-xl font-bold text-gray-900 mb-3">Other Ways to Help</h3>
          <div className="space-y-2 text-gray-700">
            <p>• Donate food items for community meals</p>
            <p>• Volunteer your time</p>
            <p>• Sponsor housing</p>
            <p>• Pray for our community</p>
          </div>
        </div>
      </div>
    </div>
  );
}
